import React, { useEffect, useState } from 'react';
import mixpanel from 'mixpanel-browser';
import { useDispatch, useSelector } from 'react-redux';

import { FormControl, Input, InputLabel, MenuItem, Select } from '@mui/material';

import {
  getVehicleMakeAndModelInfo,
  receivedVehicleMakeAndModelInfo,
  getVehicleModelInfo,
  updateVehicleInfo,
} from '../../../actions';

import {
  ALL_CAR_MAKES,
  ALL_COLORS,
  BLACK,
  SELECT_MAKE,
  SELECT_MODEL,
  SELECT_COLOR,
  SELECT_YEAR,
  AUTO_TYPE,
  MILEAGE,
  MAZDA,
} from '../../../constants/Dashboard/Financing/auto';

import './AutoFinancing.css';

export const AutoFinancing = ({ checkRates, user, handleVehicleYear }) => {
  const dispatch = useDispatch();

  const { MODELS, YEARS, AUTO_TYPES, model, year, auto_type, mileage, defaultColor, make } =
    useSelector(
      ({
        vehicleReducer: { MODELS, YEARS, AUTO_TYPES, model, year, auto_type, mileage, color, make },
      }) => ({
        MODELS,
        YEARS,
        AUTO_TYPES,
        model,
        year,
        auto_type,
        mileage,
        defaultColor: color,
        make,
      }),
    );

  const [makeState, setMake] = useState(make);
  const [yearState, setYearState] = useState(year);
  const [color, setColor] = useState(defaultColor || BLACK);
  const [autoTypeState, setAutoType] = useState(auto_type);
  const [mileageState, setMileageState] = useState(mileage || '');

  useEffect(() => {
    if (makeState || mileageState || yearState) {
      dispatch((dispatch) =>
        updateVehicleInfo(dispatch, {
          make: makeState,
          color,
          auto_type: autoTypeState,
          mileage: mileageState,
          year: yearState,
        }),
      );
    }
  }, [makeState, mileageState, yearState]);

  useEffect(() => {
    if (makeState) {
      dispatch(getVehicleMakeAndModelInfo);
      dispatch(
        // TO DO - format better so we don't have to make an exception for Mazda
        receivedVehicleMakeAndModelInfo({
          make: makeState === MAZDA ? makeState.toUpperCase() : makeState.split('-').join('_'),
          user,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [makeState]);
  useEffect(() => {
    setAutoType((prevState) => {
      if (prevState !== auto_type) {
        return auto_type;
      }
      return prevState;
    });
  }, [auto_type]);

  useEffect(() => {
    handleVehicleYear((prevYear) => {
      if (prevYear !== year) {
        return year;
      }
      return prevYear;
    });
  }, [year]);

  return (
    <div>
      <div className="loans-financing-field-row-wrapper">
        <div className="loans-financing-field-wrapper">
          <InputLabel id="auto-loans-financing-input-label">{SELECT_MAKE}</InputLabel>
          <FormControl sx={{ width: '100%' }}>
            <Select
              id="auto-financing-select-helper"
              value={makeState}
              onChange={(e) => {
                setMake(e.target.value);
                mixpanel.track('Auto_Loan_Calculator', {
                  FINANCE_FIELD: 'MAKE DROPDOWN',
                  MAKE: e.target.value,
                });
              }}
            >
              {ALL_CAR_MAKES.map((make) => (
                <MenuItem key={make} value={make}>
                  {make.split('_').join(' ')}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        <div className="loans-financing-field-wrapper">
          <InputLabel id="auto-loans-financing-input-label">{SELECT_MODEL}</InputLabel>
          <FormControl sx={{ width: '100%' }}>
            <Select
              id="auto-financing-select-helper"
              value={model}
              onChange={(e) => {
                dispatch((dispatch) => getVehicleModelInfo(dispatch, e.target.value));
                mixpanel.track('Auto_Loan_Calculator', {
                  FINANCE_FIELD: 'MODEL DROPDOWN',
                  MODEL: e.target.value,
                });
              }}
            >
              {MODELS.map((model) => (
                <MenuItem key={model} value={model}>
                  {model}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>

      <div className="loans-financing-field-row-wrapper">
        <div className="loans-financing-field-wrapper">
          <InputLabel id="auto-loans-financing-input-label">{SELECT_YEAR}</InputLabel>
          <FormControl sx={{ width: '100%' }}>
            <Select
              id="auto-financing-select-helper"
              value={yearState}
              onChange={(e) => {
                setYearState(e.target.value);
                mixpanel.track('Auto_Loan_Calculator', {
                  FINANCE_FIELD: 'YEAR DROPDOWN',
                  YEAR: e.target.value,
                });
              }}
            >
              {YEARS.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        <div className="loans-financing-field-wrapper">
          <InputLabel id="auto-loans-financing-input-label">{SELECT_COLOR}</InputLabel>
          <FormControl sx={{ width: '100%' }}>
            <Select
              id="auto-financing-select-helper"
              value={color}
              onChange={(e) => {
                setColor(e.target.value);
                mixpanel.track('Auto_Loan_Calculator', {
                  FINANCE_FIELD: 'COLOR DROPDOWN',
                  COLOR: e.target.value,
                });
              }}
            >
              {ALL_COLORS.map((color) => (
                <MenuItem key={color} value={color}>
                  {color}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>

      <div className="loans-financing-field-row-wrapper">
        <div className="loans-financing-field-wrapper">
          <p className="auto-type-mileage-label">{AUTO_TYPE}</p>
          <FormControl
            sx={{
              m: 0,
              width: '100%',
            }}
          >
            <Select
              id="auto-financing-select-helper"
              value={autoTypeState}
              onChange={(e) => {
                setAutoType(e.target.value);
                mixpanel.track('Auto_Loan_Calculator', {
                  FINANCE_FIELD: 'AUTO TYPE DROPDOWN',
                  AUTO_TYPE: e.target.value,
                });
              }}
            >
              {AUTO_TYPES.map((category) => (
                <MenuItem key={category} value={category}>
                  {category}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className="loans-financing-field-wrapper">
          <p className="auto-type-mileage-label">{MILEAGE}</p>
          <FormControl
            sx={{
              m: 0,
              width: '100%',
            }}
          >
            <Input
              id="auto-financing-select-helper"
              value={mileageState}
              placeholder="Mileage"
              autoComplete="off"
              onChange={(e) => {
                if (!isNaN(e.target.value)) {
                  setMileageState(e.target.value);
                  mixpanel.track('Auto_Loan_Calculator', {
                    FINANCE_FIELD: 'MILEAGE INPUT',
                    MILEAGE: e.target.value,
                  });
                } else {
                  setMileageState('');
                }
              }}
              disableUnderline
            ></Input>
          </FormControl>
        </div>
      </div>
    </div>
  );
};
